module.exports = __webpack_public_path__ + "media/shroom_hat.5b87b415.webm";